export const MAIN_SELECTION_ENTITIES = {
  multiPhone: "multiPhone",
  simOnly: "simOnly",
  singleBrand: "singleBrand",
  singlePhone: "singlePhone",
  singlePhoneVariant: "singlePhoneVariant",
  unknown: "unknown"
};
